import{BaseAlgoliaSearchService as e}from"./base-algolia-search-service.js";class r extends e{searchMaterialNumberById(e){return this.queryIndex({query:`"${e}"`})}}export{r as AlgoliaMaterialNumberSearchServices};
